import type { LocationDescriptorObject } from "history";

import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { StoreLocation } from "./RouteActions";
import { STORE_LOCATION } from "./RouteActionTypes";

export type LocationState = LocationDescriptorObject<any>;

export const initialLocationState: LocationState = {};

function storeLocation(_state: LocationState, { location }: StoreLocation): LocationState {
	//location is always the same object, so we make a copy to force a rerender
	return { ...location };
}

export const RouteReducer = createReducer(initialLocationState, {
	...pairActionTypeToReducer(STORE_LOCATION, storeLocation),
});
